<div class="horizontal-sidebar p-y-16 b-b-1" *ngIf="mobileQuery.matches">
  <div class="container">
    <div >
      <div class="horizontal-navbar hstack align-items-center">
        <ng-container *ngFor="let item of navItems">
          <app-horizontal-nav-item [item]="item" class="parentBox {{ item.ddType }}" [cluPermission]="!!authSessionDto && !!item.PERMISSIONS ? item.PERMISSIONS : []">
          </app-horizontal-nav-item>
        </ng-container>
      </div>
    </div>
  </div>
</div>
